module.exports = __webpack_public_path__ + "static/img/start.fabf306c.png";